import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { BsExclamationLg } from "react-icons/bs";
import { MdCancel } from "react-icons/md"; 
import { formatNumberWithCommas } from "../../../utils/commonUtils";
import { cancelManualTransfer, fetchManualTransfer } from "../../../redux/slices/manualTransferSlice";
import { pushNotifyUser } from "../../../redux/slices/pushSlice";
import { toast } from "react-toastify";

export default function CancelFuelGasManualTransfer({
  id,
  name,
  amount,
  user_id,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const status = useSelector((state) => state.payment?.status);

  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelManualTransfer(id));
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Your manual transfer of ₦${amount} for Fuel/Gas has been canceled.`,
          click: "USER",
        };
        dispatch(pushNotifyUser(pushNote));
        await dispatch(fetchManualTransfer());
        toast.success(res.payload.message);
      }
    } catch (error) {
      console.error(error);
    }
    setShowCancelModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <MdCancel className="text-red-600 text-2xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg relative w-[400px]">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-800"
              >
                <FaTimes />
              </button>
              <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                Are you sure?
              </h2>
              <p className="text-sm text-gray-600 text-center">
                Do you want to cancel this manual transfer?
              </p>
              <div className="flex justify-center items-center my-4">
                <BsExclamationLg className="text-gray-500 text-3xl" />
              </div>
              <div className="flex justify-center gap-4 mt-4">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="text-sm text-gray-500 bg-gray-100 py-2 px-4 rounded-md"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    setShowCancelModal(true);
                  }}
                  className="text-sm text-white bg-red-600 py-2 px-4 rounded-md"
                >
                  Yes, Cancel
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-30 z-40"></div>
        </>
      )}

      {showCancelModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="bg-white p-10 rounded-lg shadow-lg relative w-[450px]">
              <button
                onClick={() => setShowCancelModal(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-800"
              >
                <FaTimes />
              </button>
              <h2 className="text-xl font-semibold text-center mb-2 text-gray-800">
                Cancel Manual Transfer
              </h2>
              <p className="text-center mb-4">
                You’re about to cancel a fuel/gas manual transfer for:
              </p>
              <div className="text-center mb-4">
                <p className="font-medium">{name}</p>
                <p className="text-sm">
                  ₦{formatNumberWithCommas(amount)}
                </p>
              </div>

              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowCancelModal(false)}
                  className="bg-gray-100 text-sm text-gray-500 px-4 py-2 rounded-md"
                >
                  Close
                </button>
                <button
                  className="flex gap-2 items-center bg-red-600 text-white px-4 py-2 rounded-md"
                  onClick={handleCancel}
                  disabled={status === "loading"}
                >
                  {status === "loading" ? (
                    <>
                      <FaSpinner className="animate-spin" />
                      Cancelling...
                    </>
                  ) : (
                    <>
                      <FaTimes className="w-4 h-4" />
                      Cancel
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-30 z-40"></div>
        </>
      )}
    </>
  );
}
